export const SET_APP_INFO = 'SET_APP_INFO'
